import React from "react";

import { useTranslation } from "utils";

import { Flex, Icon, IconLinkButton, Svg, Tag, Typography } from "components";

import { useDocScanPromoCard } from "pages/app/document-scan/hooks/useDocScanPromoCard";

const TITLE_ID = "import-crop-data-promo-title";

export const ImportCropDataPromoCard = ({ onTryItOut }: { onTryItOut: () => void }) => {
  const { t } = useTranslation("docScans");
  const { isVisible, dismiss } = useDocScanPromoCard();

  if (!isVisible) return null;

  const tryItOut = () => {
    dismiss();
    onTryItOut();
  };

  return (
    <section className="import-crop-data-promo-card" aria-labelledby={TITLE_ID} data-testid="import-crop-data-promo-card">
      <div className="import-crop-data-promo-card-illustration">
        <Svg svgName="misc/import_crop_data_promo" className="import-crop-data-promo-card-illustration-art" />
        <button
          type="button"
          className="import-crop-data-promo-card-close"
          aria-label={t("promoCard.dismiss")}
          data-testid="import-crop-data-promo-dismiss"
          onClick={dismiss}
        >
          <Icon iconName="tabler/x" size="m" />
        </button>
      </div>

      <Flex align="center" justify="space-between" gap="0.5rem">
        <Typography variant="h4" id={TITLE_ID} className="margin-0">
          {t("promoCard.title")}
        </Typography>
        <Tag colour="blue" text={t("upload.newBadge")} />
      </Flex>

      <Typography variant="paragraph-m" className="margin-0">
        {t("promoCard.description")}
      </Typography>

      <IconLinkButton
        className="import-crop-data-promo-card-cta"
        dataTestId="import-crop-data-promo-cta"
        iconType="arrow"
        text={t("promoCard.cta")}
        onClick={tryItOut}
      />
    </section>
  );
};
